// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sa-2";
export var chatLink = "_sa-0";
export var chatText = "_sa-1";